module.exports = __webpack_public_path__ + "static/media/first_home.6039e49f.png";